import { render, staticRenderFns } from "./logEmailPopup.vue?vue&type=template&id=23da85f0&scoped=true&"
import script from "./logEmailPopup.vue?vue&type=script&lang=js&"
export * from "./logEmailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da85f0",
  null
  
)

export default component.exports